import styled, { css } from 'styled-components';

export const Th = styled.th<{ active?: boolean; sortDir?: -1 | 1 | number; center?: boolean }>`
  font-weight: 800;
  opacity: 0.8;

  ${({ onClick }) =>
    onClick &&
    css`
      cursor: pointer;
    `}

  ${({ center }) =>
    center &&
    css`
      text-align: center;
    `}

    ${(props) =>
    props.active &&
    css`
      opacity: 1;

      ${props.sortDir === 1 &&
      css`
        &:after {
          content: ' ↑';
        }
      `}

      ${props.sortDir === -1 &&
      css`
        &:after {
          content: ' ↓';
        }
      `}
    `};
`;

export const KebabTh = styled(Th)`
  width: 38px;
`;
